module.exports = {
    store: {
        en: "store",
        fi: "kauppa"
    },
    sold: {
        en: "Sold",
        fi: "Myyty"
    },
    canceled: {
        en: "Canceled",
        fi: "Peruttu"
    }
}